import { jsx as t, jsxs as l, Fragment as y } from "react/jsx-runtime";
import { useMemo as p } from "react";
import e from "./style.module.less.js";
import C from "./social-fb.svg.js";
import S from "./social-instagram.svg.js";
import A from "./social-tik-tok.svg.js";
import T from "./social-youtube.svg.js";
import L from "./social-ln.svg.js";
import _ from "./logo-white.webp.js";
import { CountryLanguageSelector as q } from "../country-language-selector/index.js";
import { DEFAULT_LANGUAGE_CODE as E, areasOfLawData as w, withDirectoryCountries as $, directoryBaseData as k } from "../../../constants.js";
import { convertToKebabCase as b } from "../../../utils/case-conversion.js";
import { getRoute as N, RouteType as I } from "../../../utils/get-route.js";
import F from "../menu/message-animated.svg.js";
import v from "../menu/spark-animated-midnight.svg.js";
import { useFeatureFlags as D } from "../../../context/config-context.js";
const R = [
  {
    name: "Facebook",
    link: "https://www.facebook.com/asklawconnect",
    Icon: C
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/asklawconnect/",
    Icon: S
  },
  {
    name: "TikTok",
    link: "https://www.tiktok.com/@asklawconnect",
    Icon: A
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/company/lawconnect/",
    Icon: L
  },
  {
    name: "Youtube",
    link: "https://www.youtube.com/@asklawconnect",
    Icon: T
  }
], x = () => /* @__PURE__ */ t("div", { className: e.socialContainer, children: R.map((i) => /* @__PURE__ */ t(
  "a",
  {
    href: i.link,
    target: "_blank",
    rel: "noreferrer",
    "aria-label": i.name,
    className: e.socialIconContainer,
    children: /* @__PURE__ */ t(i.Icon, { width: 32, height: 32, className: e.socialIcon })
  },
  i.name
)) }), ae = (i) => {
  const {
    className: a = "",
    onLanguageChange: h,
    isAuthenticated: o,
    openAuthModal: d,
    language: s = E,
    getTranslation: m,
    isLawyerSupported: g
  } = i, f = p(
    () => m("auth.copyright-terms-privacy").replace(/TERMS_LINK/g, s ? `/${s}/terms` : "/terms").replace(
      /PRIVACY_LINK/g,
      s ? `/${s}/privacy` : "/privacy"
    ),
    [m, s]
  ), r = p(() => s ? w[s] : null, [s]), n = /* @__PURE__ */ t(
    q,
    {
      onLanguageChange: h,
      language: s ?? ""
    }
  ), u = () => /* @__PURE__ */ t(
    "a",
    {
      href: "/account",
      className: `${e.menuItem}`,
      onClick: (c) => {
        o || (c.preventDefault(), d == null || d());
      },
      children: m("pages.account")
    }
  );
  return /* @__PURE__ */ t("footer", { className: `${e.footer} ${a}`, children: /* @__PURE__ */ l("div", { className: e.widthWrapper, children: [
    /* @__PURE__ */ l(
      "div",
      {
        className: `${e.logoContainer} ${r != null && r.length ? e.large : ""}`,
        children: [
          /* @__PURE__ */ t("a", { href: s ? `/${s}` : "/", className: e.logo, children: /* @__PURE__ */ t(
            "img",
            {
              src: _,
              width: 202,
              height: 28,
              alt: "LawConnect",
              loading: "lazy",
              className: e.logoImage
            }
          ) }),
          /* @__PURE__ */ t("div", { className: e.headerLanguageSelector, children: n })
        ]
      }
    ),
    r != null && r.length ? /* @__PURE__ */ t("div", { className: `${e.gridContainer} ${e.large}`, children: /* @__PURE__ */ t(
      M,
      {
        language: s,
        accountComponent: /* @__PURE__ */ t(u, {}),
        isLawyerSupported: g
      }
    ) }) : /* @__PURE__ */ t("div", { className: e.gridContainer, children: /* @__PURE__ */ t(
      W,
      {
        language: s,
        accountComponent: /* @__PURE__ */ t(u, {}),
        getTranslation: m
      }
    ) }),
    /* @__PURE__ */ l("div", { className: e.bottomBarContainer, children: [
      /* @__PURE__ */ l("div", { className: e.bottomSocialContainer, children: [
        /* @__PURE__ */ t(x, {}),
        /* @__PURE__ */ t("div", { className: e.languageSelectorContainer, children: n })
      ] }),
      /* @__PURE__ */ l("div", { className: e.copyright, children: [
        /* @__PURE__ */ t("div", { children: m("auth.copyright").replace(
          "<YEAR>",
          (/* @__PURE__ */ new Date()).getFullYear().toString()
        ) }),
        /* @__PURE__ */ l("div", { className: e.copyrightBottom, children: [
          /* @__PURE__ */ l("div", { children: [
            m("auth.copyright-description"),
            " "
          ] }),
          r != null && r.length ? /* @__PURE__ */ t("div", { dangerouslySetInnerHTML: { __html: f } }) : null
        ] })
      ] })
    ] })
  ] }) });
}, M = (i) => {
  const { language: a, accountComponent: h, isLawyerSupported: o } = i, { diyWill: d } = D(), s = p(() => {
    const n = w[a];
    return $.includes(a) ? [
      ...n,
      {
        title: k.footerTitle ?? "",
        description: k.description,
        image: k.image,
        link: "library"
      }
    ] : n;
  }, [a]), m = p(() => $.includes(a), [a]), g = o ? 5 : 4, f = p(() => {
    const n = g * 2, u = s.slice(0, n);
    return [u.slice(0, g), u.slice(g)];
  }, [s, g]), r = p(() => [
    {
      header: "Browse",
      items: [
        {
          key: "ask",
          label: "Ask a question",
          href: N(I.NEW_CHAT),
          icon: /* @__PURE__ */ t(v, { className: e.menuIcon }),
          className: `${e.menuItem} ${e.askQuestion}`
        },
        {
          key: "request",
          label: "Request a lawyer",
          href: N(I.LAWYER_REQUEST_CHAT),
          icon: /* @__PURE__ */ t(F, { className: e.menuIcon }),
          className: `${e.menuItem} ${e.requestLawyer}`,
          show: !!o
        },
        {
          key: "library",
          label: "Areas of law",
          href: `/${a}/library`,
          className: e.menuItem
        },
        {
          key: "about",
          label: "About",
          href: a ? `/${a}/about` : "/about",
          className: e.menuItem
        },
        {
          key: "account",
          node: h
        }
      ]
    },
    {
      header: "",
      items: [
        {
          key: "make-will",
          label: "Make a will",
          href: N(I.WILL_INFO),
          className: e.menuItem,
          show: a === "en-us" && d === !0
        },
        {
          key: "insights",
          label: "Insights",
          href: a ? `/${a}/insights` : "/insights",
          className: e.menuItem
        },
        {
          key: "faqs",
          label: "FAQs",
          href: a ? `/${a}/faqs` : "/faqs",
          className: e.menuItem
        },
        {
          key: "directory",
          label: "Case study directory",
          href: a ? `/${a}/directory` : "/directory",
          className: e.menuItem,
          show: m && !o
        },
        {
          key: "ai-technology",
          label: "Our AI technology",
          href: a ? `/${a}/about/ai-technology` : "/about/ai-technology",
          className: e.menuItem,
          show: !!o
        },
        {
          key: "legal-network",
          label: "Our legal network",
          href: a ? `/${a}/about/legal-network` : "/about/legal-network",
          className: e.menuItem,
          show: !!o
        },
        {
          key: "contact",
          label: "Contact us",
          href: a ? `/${a}/contact-us` : "/contact-us",
          className: e.menuItem
        }
      ]
    },
    {
      header: "Areas of law",
      items: f[0].map((n) => ({
        key: `area-1-${n.title}`,
        label: n.footerTitle ?? n.title,
        href: `/${a}/${n.link ?? b(n.title)}`,
        className: e.menuItem
      }))
    },
    {
      header: "",
      items: f[1].map((n) => ({
        key: `area-2-${n.title}`,
        label: n.footerTitle ?? n.title,
        href: `/${a}/${n.link ?? b(n.title)}`,
        className: e.menuItem
      }))
    }
  ], [a, o, m, f, h, d]);
  return /* @__PURE__ */ t(y, { children: r.map((n, u) => /* @__PURE__ */ l("div", { className: e.column, children: [
    /* @__PURE__ */ t("div", { className: e.headerLabel, children: n.header ?? "" }),
    n.items.filter((c) => c.show !== !1).map(
      (c) => c.node ? /* @__PURE__ */ t(y, { children: c.node }) : /* @__PURE__ */ t(
        "a",
        {
          href: c.href,
          className: c.className ?? e.menuItem,
          children: c.icon ? /* @__PURE__ */ l(y, { children: [
            /* @__PURE__ */ t("span", { className: e.menuItemText, children: c.label }),
            c.icon
          ] }) : /* @__PURE__ */ t(y, { children: c.label })
        },
        c.key
      )
    )
  ] }, u)) });
}, W = (i) => {
  const { language: a, accountComponent: h, getTranslation: o } = i;
  return /* @__PURE__ */ l(y, { children: [
    /* @__PURE__ */ l("div", { className: e.column, children: [
      /* @__PURE__ */ l(
        "a",
        {
          href: N(I.NEW_CHAT),
          className: `${e.menuItem} ${e.askQuestion}`,
          children: [
            o("pages.ask-a-question"),
            /* @__PURE__ */ t(v, { className: e.menuIcon })
          ]
        }
      ),
      /* @__PURE__ */ t(
        "a",
        {
          href: a ? `/${a}/about` : "/about",
          className: `${e.menuItem}`,
          children: o("pages.about")
        }
      ),
      h
    ] }),
    /* @__PURE__ */ l("div", { className: e.column, children: [
      a.includes("en") ? /* @__PURE__ */ t(
        "a",
        {
          href: a ? `/${a}/insights` : "/insights",
          className: `${e.menuItem}`,
          children: o("pages.insights")
        }
      ) : null,
      /* @__PURE__ */ t(
        "a",
        {
          href: a ? `/${a}/faqs` : "/faqs",
          className: `${e.menuItem}`,
          children: o("pages.faqs")
        }
      ),
      /* @__PURE__ */ t(
        "a",
        {
          href: a ? `/${a}/ai-technology` : "/ai-technology",
          className: `${e.menuItem}`,
          children: o("pages.ai-technology")
        }
      )
    ] }),
    /* @__PURE__ */ l("div", { className: e.column, children: [
      /* @__PURE__ */ t(
        "a",
        {
          href: a ? `/${a}/contact-us` : "/contact-us",
          className: `${e.menuItem}`,
          children: o("pages.contact-us")
        }
      ),
      /* @__PURE__ */ t(
        "a",
        {
          href: a ? `/${a}/terms` : "/terms",
          className: `${e.menuItem}`,
          children: o("pages.terms")
        }
      ),
      /* @__PURE__ */ t(
        "a",
        {
          href: a ? `/${a}/privacy` : "/privacy",
          className: `${e.menuItem}`,
          children: o("pages.privacy-policy")
        }
      )
    ] })
  ] });
};
export {
  ae as FooterComponent,
  R as SOCIAL_MEDIA_LINKS
};
